import { css, keyframes } from '@emotion/core'

export const pybkIconBgAni = keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: .3;
  }
`
export const pybkIconGiftBoxAni = keyframes`
  0%, 50%, 100% {
    transform: translate(-50%, 1px);
  }
  25%, 75% {
    transform: translate(-50%, 0);
  }
`
export const pybkIconTwinkleAni1 = keyframes`
  0%, 100% {
    transform: scale(1);
  }
  25%, 75% {
    transform: scale(2);
  }
  50% {
    transform: scale(1);
    animation-timing-function: ease-in-out;
  }
`
export const pybkIconTwinkleAni2 = keyframes`
  0%, 100% {
    transform: scale(1);
  }
  25%, 75% {
    transform: scale(1.9);
  }
  50% {
    transform: scale(1);
    animation-timing-function: ease-in-out;
  }
`
export const pybkIconTwinkleAni3 = keyframes`
  0%, 100% {
    transform: scale(0.79);
  }
  25%, 75% {
    transform: scale(1.1);
  }
  50% {
    transform: scale(0.79);
    animation-timing-function: ease-in-out;
  }
`
export const pybkIconTwinkleAni4 = keyframes`
  0%, 100% {
    transform: scale(0.69);
  }
  25%, 75% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.69);
    animation-timing-function: ease-in-out;
  }
`

export const EventFloatingButtonStyle = css`
  &.payback-btn {
    z-index: 2;
    position: absolute;
    top: 46px;
    right: 116px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 38px;
    height: auto;
    &.no-telegram-btn {
      right: 14px;
    }
    &.item-shop {
      top: 0;
      right: 14px;
    }
    // MatchTab 내 출력 (*PC 스타일만 고려한 스타일입니다)
    &.match-tab {
      border-radius: 0;
      position: static;
      margin: 0 auto 0 2px;
      transform: translateY(-3px);
    }
    &.header {
      position: static;
      float: right;
      width: 35px;
      height: 40px;
      border-radius: 0;
      margin-right: 3px;
      .payback-icon-wrap {
        transform: scale(0.735);
      }
    }
    &.menu {
      position: static;
      margin: 0 8px 0 auto;
      transform: scale(.9) translateY(-1px);
    }
    .payback-icon-wrap {
      position: relative;
      width: 35px;
      height: 35px;
      > img {
        position: absolute;
      }
      .payback-icon {
        &--bg { 
          top: 54%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 48px;
          height: auto;
          object-fit: cover;
          animation: ${pybkIconBgAni} 1.2s infinite forwards;
        }
        &--gift-box {
          top: 1px;
          left: 50%;
          transform: translateX(-50%);
          width: 32px;
          height: 32px;
          object-fit: cover;
          animation: ${pybkIconGiftBoxAni} 2.4s infinite forwards;
        }
        &--twinkle {
          height: auto;
          object-fit: cover;
          &:nth-of-type(3) {
            top: 7px;
            left: 0; 
            width: 6px;
            animation: ${pybkIconTwinkleAni1} 2.4s infinite forwards;
            animation-delay: .4s;
          }
          &:nth-of-type(4) {
            top: 3px;
            right: 1px;
            width: 6px;
            animation: ${pybkIconTwinkleAni2} 2.4s infinite forwards;
          }
          &:nth-of-type(5) {
            top: 14px;
            left: -2px;
            width: 8px;
            animation: ${pybkIconTwinkleAni3} 2.4s infinite forwards;
          }
          &:nth-of-type(6) {
            top: 10px;
            right: 3px;
            width: 10px;
            transform: scale(0.69);
            animation: ${pybkIconTwinkleAni4} 2.4s infinite forwards;
            animation-delay: 0.8s;
          }
        }
        &--txt {
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 34px;
          height: auto;
          object-fit: cover;
        }
      }
    }
  }
`
